import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { Button, CustomStateButton, Href, Input, Link, Submit } from "../../../../Constant";
import { CUSTOM_BUTTONS } from "../../../../Data/Buttons/DefaultStyle";
import { Btn, ToolTip } from "../../../../AbstractElements";

const FlateCustomStateButtons = () => {
  const [buttonATooltip, setButtAtooltip] = useState(false);
  const buttonAToggle = () => setButtAtooltip(!buttonATooltip);
  const [buttonInputTooltip, setButtInputtooltip] = useState(false);
  const buttonInputToggle = () => setButtInputtooltip(!buttonInputTooltip);
  const [buttonInputSubmitTooltip, setButtInputSubmittooltip] = useState(false);
  const buttonInputSubmitToggle = () => setButtInputSubmittooltip(!buttonInputSubmitTooltip);
  const [button, setButton] = useState(false);
  const buttonToggle = () => setButton(!button);
  
  return (
    <Card>
      <CommonCardHeader title={CustomStateButton} span={CUSTOM_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn tag="a" href={Href} color="primary" id="Tooltip-36" className="btn-square">{Link}</Btn>
        <ToolTip target="Tooltip-36" isOpen={buttonATooltip} toggle={buttonAToggle}>btn btn-primary</ToolTip>
        <Btn as="input" type="button" value="Input" color="secondary"  id="Tooltip-37" className="btn-square">{Input}</Btn>
        <ToolTip target="Tooltip-37" isOpen={buttonInputTooltip} toggle={buttonInputToggle}>btn btn-secondary</ToolTip>
        <Btn as="input" type="submit" value="Submit" color="success"  id="Tooltip-38" className="btn-square">{Submit}</Btn>
        <ToolTip target="Tooltip-38" isOpen={buttonInputSubmitTooltip} toggle={buttonInputSubmitToggle}>btn btn-success</ToolTip>
        <Btn color="info" id="Tooltip-39" className="btn-square">{Button}</Btn>
        <ToolTip target="Tooltip-39" isOpen={button} toggle={buttonToggle}>btn btn-info</ToolTip>
      </CardBody>
    </Card>
  );
};

export default FlateCustomStateButtons;
